import { CommonDateRange } from 'components';
import React, { useContext, useEffect, useState } from 'react'
import { BsDownload } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi';
import moment from 'moment';
import { getJournalReport, getPLR } from '_services/reportService/reportService';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { Link } from 'react-router-dom';
import { UserContext } from 'context';

const ProfitAndLossReport = () => {

    const { generalLedgerDate, setGeneralLedgerDate } = useContext(UserContext);
    const [pLRData, setPLRData] = useState({});
    const [loading, setLoading] = useState(false);
    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setGeneralLedgerDate(newRange)
    };

    useEffect(() => {
        getPLRList()
    }, [selectedRange])

    const getPLRList = async () => {
        setLoading(true)
        const payload = {
            company_id: StorageService.getCompanyId(),
            start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        }
        try {
            const res = await getPLR(payload);
            if (res?.responseCode == 200) {
                setPLRData(res?.data)
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const resetFunction = () => {
        const newStartDate = moment().startOf('month');
        const newEndDate = moment().endOf('month');

        setSelectedRange({
            startDate: newStartDate,
            endDate: newEndDate,
        });
        setGeneralLedgerDate({
            startDate: newStartDate,
            endDate: newEndDate,
        });
    };

    return (
        <>
            <div className='__znDe_mainBx'>
                <div>
                    <div className='panel-heading'>
                        <h2><span>Profit and Loss</span></h2>

                        <div className='panel-ctrls report-control'>
                            <div>
                                <CommonDateRange
                                    key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                    initialStartDate={selectedRange.startDate}
                                    initialEndDate={selectedRange.endDate}
                                    onApply={handleApply}
                                />
                            </div>

                            <button className='__bxs_srBtn'>
                                <BsDownload />
                            </button>

                            <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                                <FiRefreshCcw />
                            </button>
                        </div>

                        {/* <div className='panel-ctrls report-control'>
                            <div class="dropdown">
                                <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    This Year
                                    <FaCaretDown />
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>
                                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                            </div>

                            <button className='__bxs_srBtn'>
                                <IoSettingsOutline />
                            </button>

                            <button className='__bxs_srBtn'>
                                <BsDownload />
                            </button>

                            <button className='__bxs_srBtn'>
                                <FaPrint />
                            </button>

                            <button className='__bxs_srBtn'>
                                <BsPencil />
                            </button>

                            <button className='__bxs_srBtn'>
                                <FiRefreshCcw />
                            </button>
                        </div> */}
                    </div>
                </div>

                <div className='__hrlMain_dix'>
                    <div className='voucher report-voucher  printable'>
                        <div className='__mainPanel'>
                            <div className="panel panel-primary">
                                <div className='panel-body '>
                                    <div className='py-20 block-ui block-ui-anim-fade'>
                                        <div className='clear-both text-center p-10'>
                                            <div class="__hrlMx_head" >
                                                <p>{pLRData?.company?.company ? pLRData?.company?.company : '-'}</p>
                                                <h4>Profit and Loss</h4>
                                                <h5>From <span> {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""} </span>  To <span> {pLRData?.end_date ? utils.getDateByApiResponse(pLRData?.end_date) : ""} </span></h5>
                                            </div>
                                        </div>

                                        <div className='clear-both'>
                                            {loading ? <span className='m-5 commonCenter_avt'> Loading... </span> :
                                                <div className='report-table mt-15'>
                                                    <div className='rpt-head'>
                                                        <div className='rpt-cell rpt-col-item1 text-left'> Income </div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""} </div>
                                                    </div>

                                                    {pLRData?.Income?.income?.map((expenseItem, expenseIndex) => {
                                                        return (
                                                            <React.Fragment key={expenseIndex}>
                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item1 text-left'>{expenseItem?.name}</div>
                                                                        <div className='rpt-cell rpt-col-qty1 text-end'>&nbsp;</div>
                                                                    </div>
                                                                    {expenseItem?.accounts?.map((el, ind) => {
                                                                        return (
                                                                            <div className='row-sub-total' key={ind}>
                                                                                <div className='rpt-cell rpt-col-item1 pl-30'>{el?.name}</div>
                                                                                <div className='rpt-cell rpt-col-qty1 text-end'>
                                                                                    {/* <Link to={`/report/general_ledger/general_ledger_details/${el?._id}`}> */}
                                                                                    {el?.balance}
                                                                                    {/* </Link> */}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                    <div className='row-total'>
                                                                        <div className='rpt-cell rpt-col-item1'>Total {expenseItem?.name} </div>
                                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {expenseItem?.balance} </div>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    })}

                                                    <div className='row-total'>
                                                        <div className='rpt-cell rpt-col-item1'>Total Income </div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {pLRData?.Income?.total_income} </div>
                                                    </div>
                                                    <div className='rpt-head'>
                                                        <div className='rpt-cell rpt-col-item1 text-left'> Expenses </div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""} </div>
                                                    </div>

                                                    {pLRData?.Expenses?.expenses?.map((expenseItem, expenseIndex) => {
                                                        return (
                                                            <React.Fragment key={expenseIndex}>
                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item1 text-left'>{expenseItem?.name}</div>
                                                                        <div className='rpt-cell rpt-col-qty1 text-end'>&nbsp;</div>
                                                                    </div>
                                                                    {expenseItem?.accounts?.map((el, ind) => {
                                                                        return (
                                                                            <div className='row-sub-total' key={ind}>
                                                                                <div className='rpt-cell rpt-col-item1 pl-30'>{el?.name}</div>
                                                                                <div className='rpt-cell rpt-col-qty1 text-end'>
                                                                                    {/* <Link to={`/report/general_ledger/general_ledger_details/${el?._id}`}> */}
                                                                                    {el?.balance}
                                                                                    {/* </Link> */}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                    <div className='row-total'>
                                                                        <div className='rpt-cell rpt-col-item1'>Total {expenseItem?.name} </div>
                                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {expenseItem?.balance} </div>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    })}

                                                    <div className='row-total'>
                                                        <div className='rpt-cell rpt-col-item1'>Total Expenses </div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {pLRData?.Expenses?.total_expense} </div>
                                                    </div>

                                                    <div className='row-total'>
                                                        <div className='rpt-cell rpt-col-item1'>Total Profit/Loss</div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'> {pLRData?.total_profit_or_loss} </div>
                                                    </div>
                                                </div>}
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ProfitAndLossReport